module.exports = __webpack_public_path__ + "static/houseTest-35df4c5172b1cbc53ecf0267b40e6f1a.jpg";